import React from 'react';
import { Button, Container, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const TopSection = () => {
	const textAnimation = {
		hidden: { x: -100, opacity: 0 },
		visible: { x: 0, opacity: 1 },
	};

	const imageAnimation = {
		hidden: { x: 100, opacity: 0 },
		visible: { x: 0, opacity: 1 },
	};

	return (
		<>
			<div
				style={{
					background:
						'radial-gradient(ellipse at center, #613da7 0, #2e1c56 100%)',
					color: 'white',
					paddingTop: '80px',
				}}>
				<Container sx={{ padding: '20px' }}>
					<Grid container spacing={6} alignItems='center'>
						<Grid item xs={12} md={9}>
							<motion.div
								initial='hidden'
								animate='visible'
								transition={{ duration: 1 }}
								variants={textAnimation}>
								<Typography
									variant='h4'
									gutterBottom
									sx={{ fontWeight: 'bold' }}>
									ECOMMERCE WEBSITE DEVELOPMENT SERVICES
								</Typography>
								<Typography paragraph>
									Are you planning to expand your business by reaching out to
									your customers online? An eCommerce website would be the best
									option to enhance your customer base and increase your sales.
									Whether you want to create your first online store or upgrade
									an existing one, we can help you out with our results-driven
									eCommerce website development services. Hire experienced
									eCommerce website developers from Webguru Infosystems to build
									a top-notch online store and attract more customers. We
									promise you a rich user interface, seamless checkout process,
									advanced security features, easy-to-manage product inventory,
									and much more.
								</Typography>
								<Button
									sx={{ padding: '10px 30px' }}
									variant='contained'
									color='primary'
									onClick={() => console.log('Quick Enquiry clicked')}>
									Quick Enquiry
								</Button>
								<Button
									sx={{ marginLeft: '20px', padding: '10px 30px' }}
									variant='outlined'
									color='primary'
									onClick={() => console.log('See Our Work clicked')}>
									See Our Work
								</Button>
							</motion.div>
						</Grid>
						<Grid item xs={12} md={3}>
							<motion.div
								initial='hidden'
								animate='visible'
								transition={{ duration: 1 }}
								variants={imageAnimation}>
								<img
									src='https://www.webguru-india.com/assets/images/ecommerce-website-design-services-banner-img-new.webp'
									alt='Ecommerce banner'
									style={{
										width: '100%',
										height: 'auto',
										marginBottom: '20px',
									}}
								/>
								<img
									src='https://www.webguru-india.com/assets/images/ecommerce-website-design-services-ecommerce-platform.webp'
									alt='Ecommerce platform'
									style={{ width: '100%', height: 'auto' }}
								/>
							</motion.div>
						</Grid>
					</Grid>
				</Container>
			</div>
		</>
	);
};

export default TopSection;
